﻿import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-home-layout',
    templateUrl: './home-layout.component.html',
    styleUrls: ['./home-layout.component.css']
})
export class HomeLayoutComponent implements OnInit {
    body: HTMLBodyElement = document.getElementsByTagName('body')[0];

    ngOnInit() {
        this.body.classList.add('skin-blue');
        this.body.classList.add('sidebar-left');
        this.body.classList.add('fixed');
        this.body.classList.remove('login');
        this.body.style.position = 'relative';
    }
}



